import React, {Component} from 'react';
import {connect} from 'react-redux';
import {formatPhoneNumber} from '../../../../../../appModules/utilities/formatHelpers';
import PhoneButton from '../PhoneButton';
import './css/GetHelpNow.styl';

export class GetHelpNow extends Component {
  static propTypes = {
    funeralHome: React.PropTypes.object.isRequired,
  };

  render() {
    const {isPremium} = this.props.funeralHome;
    const {phone} = this.props.funeralHome.profileData;
    const formattedPhone = formatPhoneNumber(phone);

    return (
      <div className="get-help-now">
        <h1 className="get-help-now__title">Need Help Right Away?</h1>
        <p className="get-help-now__information">
          We'll help you get through the next steps.
        </p>
        <PhoneButton
          className="get-help-now__phone-number"
          phoneNumber={formattedPhone}
          isPremium={isPremium}
          showIcon={false}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  funeralHome: state.funeralHomeStore,
});

export default connect(mapStateToProps)(GetHelpNow);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/GetHelpNow/index.js